import {default as BlockWrapper} from './BlockWrapper';

export default BlockWrapper;
